<template>
  <div class="cpt-inactive-member-filter">
    <div class="filter-title">设置筛选条件 {{ tipText }}</div>
    <div
      class="condition-item"
      v-for="(item, index) in inactiveConditions"
      :key="item.id"
    >
      <div class="left">
        <el-select
          class="time-select"
          :value="item.time"
          :popper-append-to-body="false"
          @change="(value) => handleChangeCondition(index, 'time', value)"
          placeholder="选择时段"
        >
          <el-option
            v-for="timeOption in INACTIVE_TIME_OPTIONS"
            :key="'time-' + timeOption.value"
            :label="timeOption.label"
            :value="timeOption"
          />
        </el-select>
        <el-select
          class="type-select"
          :value="item.type"
          :popper-append-to-body="false"
          @change="(value) => handleChangeCondition(index, 'type', value)"
          placeholder="选择条件"
        >
          <el-option
            v-for="typeOption in INACTIVE_TYPE_OPTIONS"
            :key="'type-' + typeOption.value"
            :label="typeOption.label"
            :value="typeOption"
          />
        </el-select>
      </div>
      <div
        class="right pointer condition-item-remove"
        @click="handleRemoveCondition(index)"
      >
        <i class="iconfont icon-close-bold"></i>
      </div>
    </div>
    <template v-if="inactiveConditions.length < 3">
      <div class="divider"></div>
      <div
        class="add-condition pointer"
        @click="handleAddCondition"
      >
        <i class="iconfont icon-add-bold"></i>
        添加条件
      </div>
    </template>
  </div>
</template>

<script>
import {
  INACTIVE_TIME_OPTIONS,
  INACTIVE_TYPE_OPTIONS,
} from '_lib/constants/member-manage';
export default {
  name: 'InactiveMemberFilter',
  props: {
    inactiveConditions: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      INACTIVE_TIME_OPTIONS,
      INACTIVE_TYPE_OPTIONS,
    };
  },
  computed: {
    tipText() {
      return this.inactiveConditions.length > 1 ? '(符合以下任一条件)' : '';
    },
  },
  methods: {
    handleAddCondition() {
      this.$emit('addCondition');
    },
    handleRemoveCondition(index) {
      this.$emit('removeCondition', { index });
    },
    handleChangeCondition(index, key, value) {
      this.$emit('changeCondition', { index, key, value });
    },
  },
};
</script>

<style lang="scss">
.cpt-inactive-member-filter {
  display: flex;
  width: 316px;
  flex-direction: column;
  align-items: flex-start;
  border-radius: 8px;
  background: $d-fl-pp;
  box-shadow: 0px 3px 15px 0px rgba(0, 0, 0, 0.35);
  .filter-title {
    display: flex;
    padding: 6px 8px;
    align-items: center;
    gap: 2px;
    align-self: stretch;
    border-radius: 5px;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 1;
    overflow: hidden;
    color: $d-tx-3;
    text-overflow: ellipsis;
    font-size: 12px;
    font-weight: 700;
    line-height: 16px;
    letter-spacing: 0.12px;
  }
  .condition-item {
    width: 100%;
    padding: 0 8px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 6px;
    .left {
      display: flex;
      align-items: center;
      gap: 1px;
      flex: 1 0 0;
      .time-select {
        display: flex;
        width: 100px;
        height: 44px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        background: $d-op-s2;
        input {
          border-radius: 5px 0px 0px 5px;
          &::placeholder {
            flex: 1 0 0;
            color: $d-tx-4;
            font-size: 14px;
            line-height: normal;
            letter-spacing: 0.14px;
          }
        }
      }
      .type-select {
        display: flex;
        width: 167px;
        height: 44px;
        justify-content: center;
        align-items: center;
        gap: 10px;
        flex: 1 0 0;
        background: $d-op-s2;
        input {
          border-radius: 0px 5px 5px 0px;
          &::placeholder {
            flex: 1 0 0;
            color: $d-tx-4;
            font-size: 14px;
            line-height: normal;
            letter-spacing: 0.14px;
          }
        }
      }
      .el-select {
        input {
          padding-left: 12px;
          padding-right: 30px;
        }
        .el-select__caret .el-input__icon .el-icon-arrow-up {
          font-size: 8px;
        }
      }
    }
    .right {
      display: flex;
      width: 24px;
      height: 24px;
      padding: 4px;
      justify-content: center;
      align-items: center;
      border-radius: 3px;
      & > .iconfont {
        color: $d-tx-3;
      }
    }
  }
  .divider {
    margin: 4px 8px;
    width: 100%;
    height: 1px;
    border-radius: 5px;
    background: $d-op-2;
  }
  .add-condition {
    display: flex;
    align-items: center;
    gap: 6px;
    color: $d-tx-2;
    text-align: center;
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.14px;
    padding: 6px 8px;
    &.iconfont {
      color: $d-tx-2;
    }
  }
}
</style>
